document.addEventListener('DOMContentLoaded', () => {
  function toggleClamp(ele) {
    const currentClampClass = ele.dataset.clamp ?? 'line-clamp-5';

    const text = ele.querySelector('.x-line-clamp-text');
    const seeMore = ele.querySelector('.x-line-clamp-button');

    const isClamped = text.classList.contains(currentClampClass);

    const moreText = seeMore.getAttribute('data-more-text') || 'see more';
    const lessText = seeMore.getAttribute('data-less-text') || 'see less';

    seeMore.innerText = isClamped ? lessText : moreText;
    text.classList.toggle(currentClampClass, !isClamped);
  }

  function initializeLineClamp(scope = document.body) {
    const sections = scope.querySelectorAll('.x-line-clamp') ?? [];
    sections.forEach((ele) => {
      const text = ele.querySelector('.x-line-clamp-text');

      if (text.scrollHeight > text.clientHeight) {
        const seeMore = ele.querySelector('.x-line-clamp-button');
        seeMore.classList.remove('hidden');
        seeMore.addEventListener('click', () => toggleClamp(ele));
      }
    });
  };
  initializeLineClamp();

  window.initializeLineClamp = initializeLineClamp;
});
